angular.module('bmsApp.settings').factory('UserRoleSvc', function ($http, $log, $window, $q, CRUDSvc) {

	return {
		index: function (params) {
			return CRUDSvc.get('api/role/index', params);
		},
		create: function (data) {
			return CRUDSvc.create('api/role/create', data);
		},
		read: function (data) {
			return CRUDSvc.get('api/role/read/'+data);
		},
		update: function (data) {
			return CRUDSvc.post('api/role/update/' + data.id, data);
		},
		delete: function (params) {
			return CRUDSvc.delete('api/role/delete', params);
		}
	}

});



